import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com";

export function initPostHog() {
  if (!POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
    person_profiles: "identified_only",
    capture_exceptions: true,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: "localStorage+cookie",
    sanitize_properties: (properties) => {
      // Preserve pathname so funnels by route work, but strip query params and
      // hash where oauth tokens, search filters, and PII can leak.
      const stripUrl = (v: unknown): string | undefined => {
        if (typeof v !== "string") return undefined;
        try {
          const u = new URL(v, typeof window !== "undefined" ? window.location.origin : "https://app");
          return u.origin + u.pathname;
        } catch {
          return v;
        }
      };
      if (properties["$current_url"]) {
        const cleaned = stripUrl(properties["$current_url"]);
        if (cleaned) properties["$current_url"] = cleaned;
      }
      if (properties["$referrer"]) {
        const cleaned = stripUrl(properties["$referrer"]);
        if (cleaned) properties["$referrer"] = cleaned;
      }
      return properties;
    },
  });
}

/** Identify authenticated user · ID only, no email (matches Sentry policy) */
export function identifyUser(user: { id: string; companyId?: string; role?: string }) {
  if (!POSTHOG_KEY) return;
  posthog.identify(user.id, {
    company_id: user.companyId,
    role: user.role,
  });
}

/** Reset on logout */
export function resetPostHog() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

/** Track a custom event */
export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export { posthog };
